// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gradient-background{background-image:radial-gradient(rgba(24,198,82,.5),rgba(24,198,82,0) 40vw),radial-gradient(rgba(0,154,255,.3),rgba(0,154,255,0) 40vw),radial-gradient(rgba(68,93,140,.5),rgba(68,93,140,0) 40vw);background-position:-40vw 14rem,50% 10rem,60vw 14rem,-10vw calc(14rem + 20vw),30vw calc(14rem + 20vw);background-repeat:no-repeat;background-size:80vw 80vw}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
